const firebaseConfig = {
    apiKey: "AIzaSyAkp9DjgVe2h1-abCreNcKyP41mVB74cWk",
    authDomain: "creative-agency-33a1d.firebaseapp.com",
    databaseURL: "https://creative-agency-33a1d.firebaseio.com",
    projectId: "creative-agency-33a1d",
    storageBucket: "creative-agency-33a1d.appspot.com",
    messagingSenderId: "831007840437",
    appId: "1:831007840437:web:2e76089046250ae315c6fc"
  };

  export default firebaseConfig;